const advertisingContent = {
  RADIO: {
    name: `Radio`,
    channel: [
      `ACC`,
      `Activation Network`,
      `Advantage Reach`,
      `Alex Marlow`,
      `Andy Cohen`,
      `Barstool`,
      `Barstool Breakfast`,
      `Beacon Weekday`,
      `Beacon Weekend`,
      `The Ben Shapiro Radio Show`,
      `BIG 10`,
      `BIG 12`,
      `Bloomberg`,
      `Comedy Central - Bonfire`,
      `The Brian Kilmeade Show`,
      `Fox News - Brian Kilmeade`,
      `Fox News on SXM`,
      `The Buck Sexton Show`,
      `Business Radio`,
      `CBS Sports`,
      `The Charlie Kirk Show`,
      `Chicks in the Office`,
      `Chris Plante`,
      `Clay Travis & Buck`,
      `CNBC on SXM`,
      `CNN on SXM`,
      `Colin Cowherd`,
      `Comedy Central`,
      `Comedy Greats`,
      `The Dan Bongino Show`,
      `The Dan Patrick Show`,
      `Dave Ramsey`,
      `Daybreak`,
      `Dennis Prager`,
      `Triumph - Dr. Laura`,
      `ESPN Radio`,
      `ESPN Xtra`,
      `ESPNU`,
      `Evening Yak`,
      `Faction Talk`,
      `FC Soccer`,
      `FC Soccer Counter Attack`,
      `FC Soccer Football Show`,
      `FC Soccer Grumpy`,
      `Fox 24/7`,
      `Fox Business`,
      `Fox Sports`,
      `Glenn Beck Radio Program`,
      `Fox News - Guy Benson`,
      `Handel on the Law`,
      `Howard 101`,
      `Howard Stern`,
      `The Hugh Hewitt Show`,
      `iHeart Radio`,
      `Info Today`,
      `Jason Ellis`,
      `Jeff and Larry`,
      `Jeff Lewis`,
      `Joe Madison`,
      `Joe Pags`,
      `Urban View - Karen Hunter`,
      `Keyshawn`,
      `JWill & Zubin`,
      `KIIS FM`,
      `KNX`,
      `Lars Larson`,
      `Mad Dog Sports`,
      `Mark Levin`,
      `Markley`,
      `Van Camp & Robbins`,
      `Max Kellerman`,
      `Mike Gallagher`,
      `MSNBC`,
      `Nancy Grace`,
      `NASCAR`,
      `NBA Radio`,
      `NBC Sports`,
      `NewsBrand`,
      `Newstrack`,
      `NFL Radio`,
      `Comedy Central - Nikki Glaser/You Up`,
      `Outkick the Coverage`,
      `Pac 12`,
      `Patriot`,
      `PGA Radio`,
      `POTUS`,
      `Progress`,
      `Radio Advantage`,
      `Radio Classics`,
      `Red Eye Radio`,
      `The Rush Limbaugh Show`,
      `Savage Nation`,
      `Sean Hannity`,
      `Michael Smerconish`,
      `Sports Fantasy`,
      `The Dana Show`,
      `The Odd Couple`,
      `The Schnitt Show`,
      `Todd Schnitt`,
      `Triumph`,
      `Triumph News`,
      `Urban View`,
      `Volume`,
      `Patriot - David Webb`,
      `Westwood One`,
      `WHTZ`,
      `Patriot - Andrew Wilkow`,
      `The Wilkow Majority`,
      `Doctor Laura`,
      `Dr Laura`,
      `Stocks`,
      `KFI`,
      `Handel`,
      `Bill Handel`,
      `Bill Handle`,
      `KFI 640`,
      `AM 640`,
      `America`,
      `Liberty`,
      `Bonfire`,
      `Business Radio - Janet Alvarez`,
      `Business Radio - Dan Loney`,
      `Patriot - Stacy Washington`,
      `Janet Alvarez`,
      `Dan Loney`,
      `Stacy Washington`,
      `Stacy on the Right`,
      `The Black Eagle`,
      `Breitbart Daily News`,
      `Wharton Business Daily`,
      `The Business Briefing`,
      `H101`,
      `H 101`,
      `Megyn Kelly`,
      `Timeout`,
      `Rural Radio`,
      `Team Coco`,
      `Conan O\`Brien`,
      `HLN on SXM`,
      `Fox Headline on SXM`,
      `Joel Osteen`,
      `MLB Radio`,
      `Radio Andy`,
      `Rawdog Comedy`,
      `Fight Nation`,
      `Nascar Radio`,
      `Brian Kilmeade`,
      `Guy Benson`,
      `Triumph - Megyn Kelly`,
      `Freedom`,
      `Jill On Money`,
      `Jill Schlessinger`,
      `WRKO-AM`,
      `Howie Carr`,
      `Grace Curley`
    ]
  },
  STREAMING: {
    name: `Streaming`,
    channel: [
      `Fox News Audio`
    ]
  },
  SMART_SPEAKER: {
    name: `Smart Speaker`,
    channel: [
      `CNN`,
      `Fox Brief`,
      `Fox Business`,
      `Fox News`,
      `Fox Weather Update`,
      `Reuters`
    ]
  },
  PODCASTS: {
    name: `Podcasts`,
    channel: [
      `#SistersInLaw`,
      `48 Hours`,
      `Accelerate Your Business Growth`,
      `Adam Carolla`,
      `Adventure Zone`,
      `Advisory Opinions`,
      `All the Hacks`,
      `The Andrew Klavan Show`,
      `AskPat 2.0`,
      `Automators`,
      `Behind the Baller with Ben Baller`,
      `The Ben Shapiro Show`,
      `Bigger Pockets Real Estate Podcast`,
      `Bill O'Reilly's No Spin News and Analysis`,
      `Blessed + Bossed Up`,
      `Blind Landing`,
      `Blocked and Reported`,
      `Breaking Banks Fintech`,
      `Brian Windhorst`,
      `Build For Tomorrow`,
      `Business Wars`,
      `C-Suite Network`,
      `CBS Podcast Network`,
      `The Chad Prather Show`,
      `The Charlie Kirk Show`,
      `Cheap Heat`,
      `Congratulations with Chris D'Elia`,
      `Chuck Rosenberg`,
      `Clayton Morris`,
      `Cleared Hot`,
      `Cold Case Files`,
      `Commentary Magazine Podcast`,
      `Connected`,
      `Conservative Review with Daniel Horowitz`,
      `Cool Stuff Ride Home`,
      `Creating Confidence`,
      `Creator Lab`,
      `The Dan Bongino Show`,
      `Dave Lukas`,
      `David Plouffe`,
      `Decoder`,
      `Dennis Prager`,
      `Dinesh D'Souza`,
      `Don't Ask Tig`,
      `Don't Keep Your Day Job`,
      `Donny Deutsch`,
      `Duck Call Room`,
      `Dumb People Town`,
      `Ear Biscuits`,
      `First Things First`,
      `FOMO Sapiens`,
      `Future Hindsight`,
      `Get Up!`,
      `Golic and Wingo`,
      `Good Life Project`,
      `This Morning with Gordon Deal`,
      `Graham Allen's Dear America`,
      `Hack the Entrepreneur`,
      `Honestly with Bari Weiss`,
      `The Hugh Hewitt Show`,
      `iHeart Radio`,
      `Impact Theory`,
      `Inside of You`,
      `James Altucher`,
      `Jay Nordlinger`,
      `On Purpose with Jay Shetty`,
      `Jeff Fisher`,
      `Joe Rogan`,
      `John Solomon Reports`,
      `Jon Miller`,
      `The Wolf's Den with Jordan Belfort`,
      `The Jordan Harbinger Show`,
      `The Kara Goldin Show`,
      `Lauren Chen`,
      `Lex Fridman Podcast`,
      `London Calling`,
      `Longform`,
      `Louder with Crowder`,
      `Love Murder`,
      `Mac Power Users`,
      `The Majority Report with Sam Seder`,
      `Make Me Smart with Kai and Molly`,
      `WTF with Marc Maron`,
      `Marketplace`,
      `Marketplace Morning Report`,
      `Matt Walsh`,
      `Matthew West`,
      `Michael Knowles`,
      `Michael Moore`,
      `Mickstape`,
      `MMQB NFL`,
      `Monday Morning Podcast`,
      `Some More News`,
      `Morning Invest`,
      `Murder Made Me Famous`,
      `Murder With My Husband`,
      `Nerdificent`,
      `Off The Beat`,
      `Omnibus`,
      `Optimal Health Daily`,
      `Optimal StartUp Daily`,
      `Our Fake History`,
      `Pardon my Take`,
      `Part of the Problem`,
      `Passive Real Estate Investing`,
      `Pat Gray Unleashed`,
      `The Peter Schiff Show`,
      `Unashamed with Phil and Jase Robertson`,
      `Pivot`,
      `Pod Save the World`,
      `Political Gabfest`,
      `Problem Solvers`,
      `Raw Data`,
      `Real Estate Rookie`,
      `Redacted`,
      `RedHanded`,
      `Relatable with Allie Beth Stuckey`,
      `Revisionist History`,
      `Rick & Bubba University`,
      `Ricochet Podcast`,
      `Ross Tucker`,
      `Rudy Giuliani's Common Sense`,
      `School of Greatness`,
      `Sebastian Gorka`,
      `Side Hustle School`,
      `Slate Money`,
      `Slightly Offensive with Elijah Schaffer`,
      `Something You Should Know`,
      `Spectacular Failures`,
      `Spittin Chiclets`,
      `Start Here`,
      `Steve Deace Show`,
      `Stu Does America`,
      `Techmeme Ride Home`,
      `The Accidental Creative`,
      `The Al Franken Podcast`,
      `The Bigger Pockets Money`,
      `The CEOcast`,
      `The Curbsiders Internal Medicine Podcast`,
      `The Daily`,
      `The Daily Stoic`,
      `The Dana Show with Dana Loesch`,
      `The Dispatch Podcast`,
      `The Ed Mylett Show`,
      `The Editors`,
      `The Eric Metaxas Show`,
      `The Erick Erickson Show`,
      `The Femsplainers`,
      `The First Degree`,
      `The Friendship Onion`,
      `The Glenn Beck Program`,
      `The Hartmann Report`,
      `The Intelligence`,
      `The Last Podcast On the Left`,
      `The Liz Wheeler Show`,
      `The Megyn Kelly Show`,
      `The Mindset Mentor`,
      `The Money Pit Home Improvement Podcast`,
      `The News and Why It Matters`,
      `The ONE Thing`,
      `The Productivity Show`,
      `The Productivityist`,
      `The Prof G Show`,
      `The Roth Effect`,
      `The Rubin Report`,
      `The Science of Happiness`,
      `The Small Business Show`,
      `The Syndicate`,
      `The Tim Pool Daily Show`,
      `The Tony DUrso Show`,
      `The Trillionaire Mindset`,
      `The Way I Heard It`,
      `This Week in Startups`,
      `Three Martini Lunch`,
      `3 Martini Lunch`,
      `Tides of History`,
      `Token CEO`,
      `Too Beautiful to Live`,
      `Townhall Review`,
      `True Underdog`,
      `Uncharted`,
      `Undisclosed`,
      `Waveform`,
      `Wealth`,
      `Power & Influence with Jason Stapleton`,
      `What a Day`,
      `What's Essential`,
      `Whitney Cummings`,
      `Women of Impact`,
      `Young and Profiting`,
      `Young Heretics`,
      `60 Minutes`,
      `World News Roundup`,
      `Face the Nation`,
      `C Suite Network`,
      `CSuite Network`,
      `Jill Schlesinger Eye on the Money`,
      `The Takeout`,
      `Andrew Klavan`,
      `MeidasTouch`,
      `Legal AF`,
      `Brand`,
      `Stay Free`,
      `Russell Brand`,
      `Morning Wire`,
      `Candace Owens`,
      `Erick Erickson`,
      `Real Estate Training`,
      `Real Estate Training & Coaching School`,
      `Three Martini Lunch`,
      `A Productive Conversation`,
      `Build Your Tribe`,
      `DarkHorse`,
      `Dark Horse`,
      `David Pakman Show`,
      `Entrepreneurs on Fire`,
      `Formula Bone F1 Show`,
      `Glenn Greenwald`,
      `Hacks on Tap`,
      `Jumpers Jump`,
      `Kim Iversen`,
      `Mo News`,
      `Officer Tatum`,
      `Rumble with Michael Moore`,
      `Al Franken`,
      `The Emily Show`,
      `The Hagmann Report`,
      `The Iced Coffee Hour`,
      `The Majority Report`,
      `The News & Why It Matters`,
      `The Personal Finance Podcast`,
      `Dave Rubin`,
      `The Witch Trials of JK Rowling`,
      `Waypoint Podcast Network`,
      `Wendy Bell Radio Podcast`,
      `Wendy Bell`,
      `RSBN`,
      `Trump`
    ]
  }
} as const;

export type advertisingContentKey = keyof typeof advertisingContent;

export default advertisingContent;
